import React, { useContext } from 'react';
import { cloneDeep } from 'lodash';
import { StandardAppConfig } from '../Components';
import { getDefaultManualAddressValidatorConfig } from '../Validators/addressValidator';

/**
 * Please don't export this - mutations to state could lead to bugs.
 * @see getDefaultBlankAppConfig
 */
const defaultBlankAppConfig: StandardAppConfig = {
    appTitle: '',
    productCode: '',
    productTitle: '',
    projectArchetype: '',
    apiKeys: {},
    baseUrl: '',
    apiUrl: '',
    helpMessages: {},
    errorMessages: {},
    addressValidatorConfig: getDefaultManualAddressValidatorConfig(),
    links: {
        termsAndConditionsLink: '',
        eligibilityDetailsLink: 'TODO//add-correct-url',
        privacyCollectionNoticeLink: '',
        productInformationLink: '',
        logoutRedirectUrl: '',
        landingPageUrl: ''
    },
    appConfig: {
        enabled: false,
        enableDebug: false,
        loaded: false,
        bypassFileUpload: false,
        profileConnectEnabled: false,
        environment: 'none',
        apigeeHost: '',
        clientIdentifiers: {},
        globalNavConfig: {
            globalNavUrl: '',
            globalNavUrlApiKey: '',
            globalNavLinksUrl: '',
            logoutUrl: ''
        }
    },
    productConfig: {
        enabled: false,
        loaded: false
    },
    appRevision: '',
    applyWaitsForSubmissionWorkflow: true,
    sessionTimeoutConfig: {
        timeoutIntervalInSeconds: 900,
        numberOfIntervals: 3
    }
};

export const getDefaultBlankAppConfig = () => cloneDeep(defaultBlankAppConfig);

export const ApplicationConfigContext = React.createContext<StandardAppConfig>(defaultBlankAppConfig);
export const useApplicationConfig = () => useContext(ApplicationConfigContext);
